import React from "react";
import { ArrowRight, Terminal } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function InitiateOptimization() {
  return <section id="initiate-optimization" className="relative flex w-full flex-col items-center justify-center overflow-hidden bg-background py-24 md:py-32 lg:py-40">
      {}
      <div className="pointer-events-none absolute inset-0 z-0 flex items-center justify-center">
        <div className="h-[600px] w-[600px] rounded-full bg-[radial-gradient(circle_at_center,var(--color-primary)_0%,transparent_70%)] opacity-15 mix-blend-screen blur-3xl md:h-[800px] md:w-[800px]" />
      </div>

      <div className="container relative z-10 mx-auto flex max-w-4xl flex-col items-center px-4 text-center md:px-6">
        {}
        <div className="mb-8 inline-flex items-center gap-2 rounded-full border border-primary/20 bg-primary/5 px-3 py-1 font-mono text-xs font-medium text-primary">
          <Terminal className="size-3" />
          <span>SYSTEM.READY</span>
        </div>

        {}
        <h2 className="mb-12 text-4xl font-bold tracking-tight text-foreground md:text-5xl lg:text-6xl">
          Ready to Streamline Your Infrastructure?
        </h2>

        {}
        <div className="group relative">
          {}
          <div className="absolute -inset-1 animate-pulse rounded-lg bg-primary/40 opacity-75 blur-lg transition duration-1000 group-hover:opacity-100 group-hover:duration-200" />
          
          <Link to="/StrategicInquiriesPage">
            <Button size="lg" className="relative h-14 bg-primary px-8 text-base font-semibold tracking-wide text-primary-foreground shadow-[0_0_40px_-10px_var(--color-primary)] hover:bg-primary/90 md:text-lg">
              Schedule Strategic Assessment
              <ArrowRight className="ml-2 size-5" />
            </Button>
          </Link>
        </div>

        {}
        <div className="mt-10 flex items-center gap-3 font-mono text-sm text-muted-foreground">
          <span className="relative flex size-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary opacity-75"></span>
            <span className="relative inline-flex size-2 rounded-full bg-primary"></span>
          </span>
          <span className="opacity-60">HQ_CONNECTION:</span>
          <span className="font-medium text-foreground">206-929-1309</span>
        </div>
      </div>
    </section>;
}